// message-tip
export const SHOW_MESSAGE_TIP = 'SHOW_MESSAGE_TIP'
export const HIDE_MESSAGE_TIP = 'HIDE_MESSAGE_TIP'
